/**
 * Версионированный localStorage кеш.
 * Сохраняет данные с версией, при загрузке сравнивает с серверной версией.
 * Если версия совпадает — данные из localStorage (мгновенно).
 * Если нет — полный запрос с сервера.
 */

const PREFIX = 'agr_cache_';

export const cacheStore = {
    /**
     * Сохранить данные + версию в localStorage.
     */
    set(key, data, version) {
        try {
            const payload = JSON.stringify({ v: version, d: data, t: Date.now() });
            localStorage.setItem(PREFIX + key, payload);
        } catch (e) {
            // localStorage full — ignore
        }
    },

    /**
     * Прочитать данные из localStorage.
     * @returns {{ data: any, version: number } | null}
     */
    get(key) {
        try {
            const raw = localStorage.getItem(PREFIX + key);
            if (!raw) return null;
            const parsed = JSON.parse(raw);
            return { data: parsed.d, version: parsed.v ?? -1 };
        } catch {
            return null;
        }
    },

    /**
     * Удалить ключ из кеша.
     */
    remove(key) {
        try {
            localStorage.removeItem(PREFIX + key);
        } catch {}
    },

    /**
     * Проверить, актуален ли кеш (версия совпадает с серверной).
     */
    isValid(key, serverVersion) {
        const cached = this.get(key);
        if (!cached) return false;
        return cached.version === serverVersion;
    },
};
